import Vue from 'vue'
import Router from 'vue-router'
import route from './../routes-types'
import store from './../store'
const Main = () => import('@/components/Main')
const Login = () => import('@/components/Login')
const Contact = () => import('@/components/Contact')
const Messages = () => import('@/components/Messages')

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    { path: route.main, name: 'main', component: Main },
    { path: route.login, name: 'login', component: Login },
    { path: route.contact, name: 'contact', component: Contact },
    { path: route.messages, name: 'messages', component: Messages, meta: { requiresAuth: true } },
    { path: '*', redirect: route.root }
  ]
})

// router.setStore(store)
router.beforeEach((to, from, next) => {
  let isLoading = store.getters.loading
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (isLoading) {
    if (requiresAuth) {
      next(route.main)
    } else {
      next()
    }
  } else {
    let notAuthorized = (store.getters.user == null)
    if (requiresAuth && notAuthorized) {
      next(route.login)
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js